import { render, staticRenderFns } from "./AlertaMsj.vue?vue&type=template&id=4dfc5bce"
import script from "./AlertaMsj.vue?vue&type=script&lang=js"
export * from "./AlertaMsj.vue?vue&type=script&lang=js"
import style0 from "./AlertaMsj.vue?vue&type=style&index=0&id=4dfc5bce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports